
define('modules/application/wizard/steps/zoneStep/zoneDetailView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi"
],

function(
  app,
  Backbone,
  jQueryUi) {

  //Creating a single zone model
  var ZoneDetailView          = Backbone.View.extend({
    template  :  "application/wizard/steps/zones/detail",
    events    :  {
      "keyup #name"  :  "updateName"
    },

    initialize              : function()          {
      var that = this;

      this.model.get("stepEventAggregator").unbind("order:changed",  this.render);
      this.model.get("stepEventAggregator").bind("order:changed",    this.render, this);

      this.model.get("stepEventAggregator").unbind("render:requested", this.render);
      this.model.get("stepEventAggregator").bind("render:requested",   this.render, this);

      window.BticinoS4B.eventAggregator.bind("zoneDetail:render", this.render, this);

      var len                = this.options.sections.length,i=0;
      if(this.model.collection){
        var selectedZoneModels = this.model.collection.filter(function(zone){
          return zone.get("selected")===true;
        });

        for(i=0;i<len;i+=1) {
          var classToInstance      = this.sectionInstancer(this.options.sections[i]);
          var zoneEventAggregator  = this.model.get("zoneEventAggregator");
          var obj                  = classToInstance;
          var objModel             = null;

          var modelInstance        = null;
          var modelName            = this.options.sections[i].name+"Model";
          if (this.model.get(modelName)===undefined)
          {
            modelInstance = new obj.Model({
              stepEventAggregator :  this.options.stepEventAggregator,
              zoneEventAggregator :  zoneEventAggregator
            });
            this.model.set(modelName, modelInstance);
          }
          else if (this.model.get(modelName).attributes) {
            objModel = this.model.get(modelName);
          }
          else {
            modelInstance = new obj.Model(_.extend({
              stepEventAggregator :  this.options.stepEventAggregator,
              zoneEventAggregator :  zoneEventAggregator
            }, this.model.get(modelName)));
            this.model.set(modelName, modelInstance);
          }

          objModel = this.model.get(modelName);
          if(obj && objModel){
            this.insertView(".accordionView", new obj.Views.titleBar ({ model   :   objModel }));
            this.insertView(".accordionView", new obj.Views.content  ({ model   :   objModel }));
          }
        }
      }
    },

    updateName                : function(e)         {
      this.model.set("name", _.escape(e.currentTarget.value));
    },

    serialize               : function()          {
      return { model: this.model };
    },

    cleanup                 : function()          {
      this.model.off(null, null, this);
    },

    replaceZoneNumber       : function(model)     {
      this.$el.find(".zoneNumber").text(model.get("number"));
    },

    afterRender             :  function()         {
      var itemView        = $(".itemContent");
      var menuView        = $(".menu");
      var topBarView      = $(".topBar");
      // var genericInfoView = this.$el.find(".genericInfo");
      var footer          = this.$el.find("footer");
      var wizardSection   = $('#wizard').height()-$('#stepList').height()-25;

      itemView.each(function(){
        var genericInfoView = $(this).parent().find(".genericInfo");
        $(this).height(wizardSection-genericInfoView.height());
      });

      $(this.el).find("h3 .titleBarcontent span").corner("2px");
      $(this.el).find(".accordionView").accordion({collapsible: true, active: 0, autoHeight: false });
      this.$el.find(".itemContent").unbind("touchmove", app.stopBubbling);
      this.$el.find(".itemContent").bind("touchmove",   app.stopBubbling, this);
    }
  });

  // Required, return the module for AMD compliance
  return ZoneDetailView;
});